package it.neckar.lizergy.model.configuration.moduleLayout.roof

import com.meistercharts.charts.pv.roofPlanning.UnusableAreas
import com.meistercharts.charts.pv.stringsPlanning.ModuleReference
import it.neckar.lizergy.model.configuration.moduleLayout.ModuleLayout.ModuleLayoutId
import it.neckar.lizergy.model.configuration.moduleLayout.planning.UnusableAreaInformation
import it.neckar.lizergy.model.configuration.moduleLayout.planning.UnusableAreaInformation.UnusableAreaId
import it.neckar.lizergy.model.configuration.moduleLayout.planning.UnusableAreasInformation
import it.neckar.uuid.HasUuid
import it.neckar.uuid.NativeUuid
import it.neckar.uuid.randomUuid4
import kotlinx.serialization.Serializable
import kotlin.uuid.Uuid

@Serializable
data class ModulesString(
  val id: StringId,
  val moduleLayoutId: ModuleLayoutId,
  val stringOfModules: List<ModuleReference>,
) : HasUuid {
  override val uuid: Uuid
    get() = id.uuid

  val numberOfModules: Int
    get() = stringOfModules.size


  @Serializable
  data class StringId(val uuid: NativeUuid) {

    override fun toString(): String {
      return uuid.toString()
    }

    fun format(): String {
      return uuid.toString()
    }

    companion object {
      fun random(): StringId {
        return StringId(randomUuid4())
      }
    }
  }
}


fun UnusableAreas.toRestApiModel(): UnusableAreasInformation {
  return UnusableAreasInformation(
    unusableAreas.map {
      UnusableAreaInformation(
        id = UnusableAreaId(it.uuid),
        location = it.location,
        size = it.size,
        description = it.description,
        rightTriangleType = it.rightTriangleType,
      )
    }
  )
}
